<template>
  <div class="apply-return">
    <div class="list">
	  <div class="item textarea acea-row row-between">
        <div>留言</div>
        <textarea
          placeholder="为保证你的权益，请尽可能详细的描述，最多200字"
          class="num"
          v-model="refund_reason_wap_explain"
		  maxlength="200"
        ></textarea>
      </div>
      <div class="item acea-row row-between">
        <div class="title acea-row row-between-wrapper">
          <div>举证</div>
          <div class="tip">可上传3张图片</div>
        </div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in refund_reason_wap_img"
            :key="img"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="refund_reason_wap_img.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="refund_reason_wap_img.length < 3"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传凭证</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
    </div>
     <button type="button" class="returnBnt bg-color-red displayblock" @click="submit" :disabled="isDisabled">提交</button>
  </div>
</template>

<script>
import { consultMsg } from "@api/order";
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
  name: "ConsultMessage",
  components: {
    VueCoreImageUpload
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      id: this.$route.params.id || 0,
      refund_reason_wap_explain: "",
      refund_reason_wap_img: [],
      isDisabled:false
    };
  },
  methods: {
	
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.data.url);
    },
    submit() {
	  let that = this;
      const refund_reason_wap_explain = trim(that.refund_reason_wap_explain);
	  if(!refund_reason_wap_explain) return that.$dialog.toast({ mes: "请填写留言" });
      that.isDisabled = true;
      consultMsg({
        refunds_id: that.id,
        content: refund_reason_wap_explain,
        voucher: that.refund_reason_wap_img.join(","),
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.$router.go(-1);
        })
        .catch(res => {
          that.isDisabled = false;
          that.$dialog.error(res.msg);
        });
    }
  },
  mounted() {
  }
};
</script>
<style scoped>
.line2 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.list{margin-top: 0;}
.apply-return .list .item .num{text-align: left;margin-left: 0.2rem;font-size: 0.28rem;width: 82%;}
.textarea{display: flex;justify-content: initial;}
.apply-return .list .item .title{display: flex;justify-content: initial;}
.apply-return .list .item .title .tip{margin-left: 0.2rem;}
</style>
